/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { CotizadorContext } from '../context';
import useCarsData from './useCarsData';
import useConfigData from './useConfigData';


const useTotalData = () => {
    const [state, setState] = useContext(CotizadorContext)
    const { getSelectedCar } = useCarsData();

    const { getConfigItem } = useConfigData();

    const getCarTotal = (car = null) => {
        const selectedCar = car ? car : getSelectedCar();
        return 0;
    }


    const getTotal = () => {
        return state.simulation_total
    }

    const getMinPrice = () => {
        return state.min_price || {
            simulation12: null,
            simulation24: null,
            simulation36: null,
            simulation48: null,
        }
    }

    return {
        getCarTotal,
        getTotal,
        getMinPrice
    };
}

export default useTotalData;